import React, { useState, useRef } from "react";
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";
import classNames from "classnames";
import * as c from "./lcTOC.module.scss";
import { slugify } from "@utils/helpers";
import { useOnClickOutside } from "@hooks/useOnClickOutside";

const LcTOC = ({ body }) => {
  const [isOpen, setIsOpen] = useState(false);
  const tocRef = useRef(null);

  useOnClickOutside(tocRef, () => setIsOpen(false));

  if (!body?.raw) return null;

  const contentDoc = JSON.parse(body.raw);
  const headings = [];

  const extractHeading = (node) => {
    if (node.nodeType === "heading-2") {
      const text = documentToPlainTextString({
        nodeType: "document",
        content: [node],
      });
      headings.push({ id: slugify(text), text });
    }
    node.content?.forEach(extractHeading);
  };

  contentDoc.content?.forEach(extractHeading);

  if (headings.length < 3) return null;

  const handleClick = (id) => {
    window.document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setIsOpen(false);
  };

  return (
    <div className={c.tocWrapper} ref={tocRef}>
      <div className={c.tocContainer}>
        <button className={classNames(c.tocToggle, { [c.tocOpen]: isOpen })} onClick={() => setIsOpen(!isOpen)}>
          <h2 className={c.tocTitle}>In this article</h2>
          <span className={c.arrowIcon} />
        </button>

        <div className={classNames(c.tocNav, { [c.tocNavVisible]: isOpen })}>
          <ul>
            {headings.map(({ id, text }) => (
              <li key={id} className={c.tocItem}>
                <button className={c.tocLink} onClick={() => handleClick(id)}>
                  {text}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LcTOC;
